export const rotate = (arr, count) => {
  const to = count < 0 ? -count : arr.length - count;
  const firstPart = arr.slice(0, to);
  const secondPart = arr.slice(to, arr.length);
  
  return secondPart.concat(firstPart);
};

export const groupBy = (arr, key, asArray = false) => {
  key = Array.isArray(key) ? key : [key];
  const map = arr.reduce((acc, item) => {
    const group = key.reduce((group, key) => group + String(item[key]), '');
    acc[group] = acc[group] || [];
    acc[group].push(item);
    return acc;
  }, {});

  if (asArray) {
    return Object.values(map);
  }
  return map;
};
